var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Icon',{key:_vm.uid,staticClass:"swoosh",attrs:{"type":"MarkerLine"}})}
var staticRenderFns = []

export { render, staticRenderFns }